/**
 * User Applications
 *
 * @component userapplications
 */

import ClassLogger from 'ClassLogger';
import Api from './_api.js';

class UserApplications {

    constructor() {
        let self = this;
        self.logger = ClassLogger(self, true);

        if ($('[data-user-applications]').length === 0) {
            return;
        }
        self.init();
    }

    init() {
        let self = this;
        const url = 'accounts/me/applications';
        self.getApplications(url);
        self.preloader($('[data-user-applications]'), 'show');

    }

    getApplications(url) {
        let self = this;
        // Request Data
        Api.request('GET', url, '')
            .then(function (response) {

                if (typeof response.data !== 'undefined' && response.data.length > 0) {
                    // the array is defined and has at least one element
                    self.populateApplications(response.data);
                }

                self.preloader($('[data-user-applications]'), 'hide');

            }).catch(function (exception) {
                self.logger.error('Processor Error', exception);
                let error_message = 'Es trat ein Fehler auf!';
                if (typeof exception === 'object'
                    && typeof exception.responseJSON === 'object'
                    && typeof exception.responseJSON.error_code !== 'undefined'
                    && typeof exception.responseJSON.error_message === 'string'
                ) {
                    error_message = exception.responseJSON.error_message;
                }
                alert(error_message);

            });

    }

    formatDate(date) {
        // parts stolen from here https://stackoverflow.com/questions/6040515/how-do-i-get-month-and-date-of-javascript-in-2-digit-format
        const startDate = new Date(date);
        const year = startDate.getFullYear();
        const day = startDate.getDate();
        const month = startDate.getMonth();
        return day + '.' + month + '.' + year;
    }

    populateApplications(data) {
        let self = this;
        let applicationOutput = [];

        // build output
        data.forEach(element => {

            const formatDate = this.formatDate(element.createdon);

            let title = element.company.contactpersons[0].title;
            if (title === null) {
                title = '';
            }

            let phoneMarkup = '';
            if (element.company.contactpersons[0].phone) {
                phoneMarkup = `<p class="u-no-margin--bottom">Tel.: ${element.company.contactpersons[0].phone}</p>`;
            }

            applicationOutput.push(`<section class="c-user-statistic-card c-user-applications__item hide">

                    <time class="u-no-margin"><small>Bewerbung verschickt am: ${formatDate}</small></time>
                    <p class="h6 u-no-margin--bottom u-color--primary">${element.job.title}</p>
                    <p class="u-extra-small-margin--bottom u-no-margin--bottom"><strong>Unternehmen:</strong> ${element.company.name}</p>

                    <p class="u-no-margin--bottom"><strong>Ansprechpartner:</strong></p>
                    <p class="u-extra-small-margin--bottom">${title} ${element.company.contactpersons[0].salutation} ${element.company.contactpersons[0].firstname} ${element.company.contactpersons[0].lastname}</p>
                    ${phoneMarkup}
                    <p class="u-extra-small-margin--bottom">E-Mail: <a href="mailto:${element.company.contactpersons[0].email}">${element.company.contactpersons[0].email}</a></p>

                    <p class="text-right u-no-margin--bottom u-extra-small-margin--top">
                        <a class="c-button c-button--icon c-button--outline c-button--tertiary c-button--small" href="${element.company.profile.uri}">
                            <span class="c-button__icon-background">
                                <svg role="presentation" class="c-button__icon u-color--tertiary"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/dist/web/spritesvg#icon-company" href="/assets/dist/web/sprite.svg#icon-company"></use></svg>
                            </span>
                            <span class="c-button__label">zum Unternehmen</span>
                        </a>
                    </p>
                    </section>`);
        });

        // print output
        $('[data-user-applications-output]').append(applicationOutput);

        // show logic
        if (applicationOutput.length > 3) {
            // show only first three items
            $('.c-user-applications__item:nth-child(-n+3)').removeClass('hide');
            // show button
            self.showButton();
        } else {
            // show all
            $('.c-user-applications__item').removeClass('hide');
        }

    }

    showButton() {
        $('[data-user-applications-showall]').removeClass('hide').on('click', function (e) {

            const $applications = $('[data-user-applications-showall]');
            e.preventDefault();
            // hide and show logic
            $('.c-user-applications__item:nth-child(n+4)').toggleClass('hide');
            $applications.toggleClass('is-triggered');

            // button label logic
            if ($applications.hasClass('is-triggered')) {
                $applications.find('.c-button__label').text('Weniger anzeigen');
            } else {
                $applications.find('.c-button__label').text('Alle anzeigen');
            }

        })
    }

    preloader($element, status) {
        let self = this;
        if (status == 'show') {
            $element.find('.c-preloader-overlay').css('display', 'block');
        } else if (status == 'hide') {
            $element.find('.c-preloader-overlay').css('display', 'none');
        }
        self.logger.info('Preloader called');
    }

}

export default new UserApplications();
